import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { SpSwitchComponent } from '@ui/sp-switch';

import { SpFormElementSettingsComponent } from './sp-form-element-settings.component';

import { SpCommonEditorModule } from '@components/sp-common-editor';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        TooltipModule,
        SpSwitchComponent,
        BsDropdownModule,
        SpCommonEditorModule,
        FormsModule,
        SpFormElementSettingsComponent,
    ],
    exports: [SpFormElementSettingsComponent],
})
export class SpFormElementSettingsModule {}
